import { BaseMmsMockService } from "services/mms/mock/entities-services/BaseMockService"
import { CommunicationService } from "services/mms/mock/CommunicationService"
import { OrganizationServiceInterface } from "interfaces/organization-service"
import { FetchMockProps } from "types/mms-base"

export class MockOrganizationService
    extends BaseMmsMockService
    implements OrganizationServiceInterface
{
    constructor(communicationService: CommunicationService) {
        super(communicationService)
    }
    useGetOrganization = (_opts?: {
        include_children?: boolean
        depth?: number
    }): FetchApiProps => {
        // mark as used to satisfy @typescript-eslint/no-unused-vars regardless of config
        void _opts
        const datas: FetchMockProps = {
            delay: 0,
            controllerFn: () => {},
        }
        return this.get(datas)
    }
    useGetEnableMultiOrganization = (): FetchApiProps => {
        const datas: FetchMockProps = {
            delay: 0,
            controllerFn: () => {},
        }
        return this.get(datas)
    }
}
